import { FIELD_PRIMITIVE__string_hash_ml_asset } from '@shared/dto/generation/graph_invoke/_fields/_primitives/string/hash/FIELD_PRIMITIVE__string_hash_ml_asset';
import { G_BUTTON__hide_unused_values } from '../../_archive/G_BUTTON__hide_unused_values';
import { G_HOOK__output__field_hovered_set } from '../_base/_hooks/G_HOOK__output__field_hovered_set';
import { G_UI_FIELD__header } from '../_base/G_UI_FIELD__header';
import { G_UI_FIELD_PRIMITIVE__string_ml_asset_hash__button_select_all } from './_buttons/G_UI_FIELD_PRIMITIVE__string_ml_asset_hash__button_select_all';
import { G_UI_FIELD_PRIMITIVE__string_ml_asset_hash_dropdown } from './G_UI_FIELD_PRIMITIVE__string_ml_asset_hash_dropdown';
import { G_UI_FIELD_PRIMITIVE__string_ml_asset_hash_list } from './G_UI_FIELD_PRIMITIVE__string_ml_asset_hash_list';

interface PROPS {
  field: FIELD_PRIMITIVE__string_hash_ml_asset;
}

export function G_UI_FIELD_PRIMITIVE__string_ml_asset_hash({ field }: PROPS) {
  /*
   * STATE
   */

  const { onMouseOver, onMouseLeave } = G_HOOK__output__field_hovered_set({ field });

  /*
   * HTML
   */

  return (
    <div
      className={`flex flex-col w-full min-w-0
    `}
      {...{ onMouseOver, onMouseLeave }}
    >
      <G_UI_FIELD__header {...{ field }}>
        <>
          <G_BUTTON__hide_unused_values {...{ property: 'generation_hide_unused_values' }} />
          <G_UI_FIELD_PRIMITIVE__string_ml_asset_hash__button_select_all {...{ field }} />
        </>
      </G_UI_FIELD__header>

      <div className="w-full bg-component min-w-0">
        {field.meta.grid2d__is_dimension ? (
          <G_UI_FIELD_PRIMITIVE__string_ml_asset_hash_list {...{ field }} />
        ) : (
          <G_UI_FIELD_PRIMITIVE__string_ml_asset_hash_dropdown {...{ field }} />
        )}
      </div>
    </div>
  );
}
